import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { toast } from "react-toastify";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
import { useMyContext } from "../../../components/Provider/CommonProvider";

const RadioStationCategoryAddEdit = ({ isModal = false, onSuccess, forceCreate = false }) => {
    const { id } = useParams();
    const isEditing = !!id && !forceCreate;
    const navigate = useNavigate();
    const { globalImageUplaodAPI, fetchRequest } = useMyContext();

    const customHeader = getItemToken("access_token");
    const baseURL = process.env.REACT_APP_Baseurl;

    const createApi = `${baseURL}/admin/radio-station/category-create`;
    const addApi = `${baseURL}/admin/radio-station/category-store`;
    const imageApi = globalImageUplaodAPI();
    const editApi = `${baseURL}/admin/radio-station/category-edit`;
    const updateApi = `${baseURL}/admin/radio-station/category-update`;

    const [formData, setFormData] = useState({
        name: "",
        slug: "",
        parent_id: "",
        in_home: 0,
        in_menu: 0,
        footer: 0,
        banner: 0,
        parent_category: 1,
    });
    const [formDataError, setFormDataError] = useState({});
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [bannerImageFile, setBannerImageFile] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false);
    const [defaultOption, setDefaultOption] = useState({
        state: "defaultOption",
        parentOption: [],
    });

    const [customFieldValues, setCustomFieldValues] = useState({});
    const combinedRef = useRef({
        name: null,
        slug: null,
    });

    const handleBlurtitle = () => {
        if (!formData?.slug) {
            generateSlug(formData?.name);
        }
    };

    const generateSlug = async (name) => {
        const slug = await slugGenerator(name);
        setFormData((prev) => ({ ...prev, slug }));
    };

    const handleInputKeyDowntitle = (event) => {
        if (!formData?.slug) {
            if (event.key === "Enter" || event.key === "Tab") {
                generateSlug(formData?.name);
            }
        }
    };

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setFormData((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
        }
        if (type === "text") {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
        if (type === "select-one") {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
        setFormDataError((prev) => ({ ...prev, [name]: "" }));
    };

    const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const ratio = width / height;
                const ratioMatch = Math.abs(ratio - expectedRatio) < 0.01;
                const dimensionMatch = width === expectedWidth && height === expectedHeight;
                resolve(ratioMatch || dimensionMatch);
            };
            img.onerror = () => toast.error("Error loading image");
        });
    };

    const handleFileChange = async (event) => {
        const { files, name } = event.target;
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
        setFormDataError((prev) => ({ ...prev, [name]: "" }));

        if (files?.length > 0) {
            const newFile = files[0];
            if (!allowedTypes.includes(newFile?.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, and PNG files are allowed.",
                }));
                if (name === "image") setCoverImageFile(null);
                if (name === "banner_image") setBannerImageFile(null);
                return;
            }

            if (name === "image") {
                setCoverImageFile(newFile);
                const isValidSize = await validateImageRatio(newFile, 1 / 1, 1080, 1080);
                if (!isValidSize) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 1:1 Ratio or 1080x1080px.",
                    }));
                }
            }
            if (name === "banner_image") {
                setBannerImageFile(newFile);
                const isValidSize = await validateImageRatio(newFile, 16 / 9, 1280, 720);
                if (!isValidSize) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 16:9 Ratio or 1280x720px.",
                    }));
                }
            }
        }
    };

    const handleClearSelectFile = (value) => {
        if (value === "image") setCoverImageFile(null);
        else setBannerImageFile(null);
    };

    const fetchDefault = async () => {
        try {
            const response = await axios.get(`${createApi}`, { headers: customHeader });
            const result = response?.data?.RadioStationCategories;
            setDefaultOption((prev) => ({ ...prev, parentOption: result || [] }));
        } catch (error) {
            console.log(error);
        }
    };

    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.name || formData?.name.trim().length < 3 || formData?.name.trim().length > 100) {
            toast.error("Name must be between 3 and 100 characters.");
            setFormDataError((prev) => ({
                ...prev,
                name: "Title cannot be empty or contain only spaces.",
            }));
            combinedRef.current["name"].focus();
            formIsValid = false;
        }
        if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
            toast.error("Slug must be between 3 and 100 characters.");
            setFormDataError((prev) => ({
                ...prev,
                slug: "Slug cannot be empty or contain only spaces.",
            }));
            combinedRef.current["slug"].focus();
            formIsValid = false;
        }
        return formIsValid;
    };

    const handleFileUpload = async (storeid) => {
        try {
            const formDataAdd = new FormData();
            formDataAdd.append("id", storeid);
            formDataAdd.append("modelName", "RadioStationCategory");
            formDataAdd.append("image", coverImageFile);
            if (bannerImageFile) formDataAdd.append("banner_image", bannerImageFile);
            formDataAdd.append("imageFields[]", "image");
            if (bannerImageFile) formDataAdd.append("imageFields[]", "banner_image");
            try {
                await fetchRequest({ method: "POST", url: imageApi, data: formDataAdd });
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
            }
            setCoverImageFile(null);
            setBannerImageFile(null);
        } catch (err) {
            toast.error(err?.response?.data?.message);
        }
    };

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "slug", "parent_id", "in_home", "in_menu", "footer", "banner"].includes(key)) {
                    formDataAdd[key] = formData[key];
                }
            }
            if (formData?.parent_category === 1) formDataAdd.parent_id = null;

            const response = await axios.post(`${addApi}`, formDataAdd, { headers: customHeader });
            const result = response?.data;
            if (result?.status) {
                try {
                    await saveCustomFieldsStrict({
                        baseURL,
                        headers: customHeader,
                        entityType: "radio_station_category",
                        entityId: result?.RadioStationCategory?.id,
                        values: customFieldValues,
                    });
                } catch (e) {
                    toast.error(e?.message || "Failed to save additional fields");
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile || bannerImageFile) {
                    await handleFileUpload(result?.RadioStationCategory?.id);
                }
                setShowOverlay(false);
                toast.success(result?.message);
                if (typeof onSuccess === "function") {
                    onSuccess(result?.RadioStationCategory?.id, formData?.name);
                } else {
                    navigate("/radio-station-categories");
                }
            } else {
                setShowOverlay(false);
                toast.error(result?.message);
            }
        } catch (err) {
            setShowOverlay(false);
            toast.error(err?.response?.data?.message);
        }
    };

    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "slug", "parent_id", "in_home", "in_menu", "footer", "banner"].includes(key)) {
                    formDataAdd[key] = formData[key];
                }
            }
            if (formData?.parent_category === 1) formDataAdd.parent_id = null;

            const response = await axios.patch(`${updateApi}/${id}`, formDataAdd, { headers: customHeader });
            const result = response?.data;
            if (result?.status) {
                try {
                    await saveCustomFieldsStrict({
                        baseURL,
                        headers: customHeader,
                        entityType: "radio_station_category",
                        entityId: id,
                        values: customFieldValues,
                    });
                } catch (e) {
                    toast.error(e?.message || "Failed to save additional fields");
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile || bannerImageFile) {
                    await handleFileUpload(id);
                }
                setShowOverlay(false);
                toast.success(result?.message);
                setWithOutRefresh(!withOutRefresh);
            } else {
                setShowOverlay(false);
                toast.error(result?.message);
            }
        } catch (err) {
            setShowOverlay(false);
            toast.error(err?.response?.data?.message);
        }
    };

    const handleStore = () => {
        if (formValidation()) {
            if (!isEditing) handleAdd();
            else handleUpdate();
        }
    };

    const fetchEditData = () => {
        axios
            .get(`${editApi}/${id}`, { headers: customHeader })
            .then((response) => {
                const result = response?.data?.RadioStationCategory;
                setFormData(result);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        fetchDefault();
    }, []);

    useEffect(() => {
        if (id && !forceCreate) {
            fetchEditData();
        }
    }, [withOutRefresh, id, forceCreate]);

    function flattenCategories(list, level = 0, result = []) {
        list.forEach((item) => {
            const indent = "    ".repeat(level);
            const prefix = level ? "• " : "";
            result.push({ id: item.id, label: `${indent}${prefix}${item.name}`, name: item.name });
            if (item.sub_category?.length) {
                flattenCategories(item.sub_category, level + 1, result);
            }
        });
        return result;
    }

    const flatOptions = flattenCategories(defaultOption?.parentOption || []);

    return (
        <>
            {showOverlay && <Response_Processing></Response_Processing>}
            {!isModal && (
                <AdminBackNavigation path="/radio-station-categories" text="Back" />
            )}
            {!isModal && (
                <AdminSaveHeader
                    heading={!isEditing ? "Add Radio Station Category" : "Edit Radio Station Category"}
                    saveText="Save"
                    saveMethod={handleStore}
                />
            )}
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        {!isEditing && <MessageHeading text="Add Radio Station Category" />}
                        <MessageLabel text="Name" className="mandatorySimple" />
                        <AdminCustomInput
                            type="text"
                            name="name"
                            value={formData?.name}
                            onChange={handleInput}
                            placeHolder="Name"
                            ref={(el) => (combinedRef.current.name = el)}
                            onBlur={handleBlurtitle}
                            onKeyDown={handleInputKeyDowntitle}
                            error={formDataError?.name}
                        />

                        <MessageLabel text="Slug" className="mandatorySimple" />
                        <AdminCustomInput
                            type="text"
                            name="slug"
                            value={formData?.slug}
                            onChange={handleInput}
                            placeHolder="slug"
                            ref={(el) => (combinedRef.current.slug = el)}
                            error={formDataError?.slug}
                        />

                        <FormContainer>
                            <div className="col-7 col-md-7 pe-2">
                                <MessageLabel text="Make as Parent Category" />
                            </div>
                            <div className="col-5 col-md-5 ps-2 text-end">
                                <AdminSwitch
                                    name="parent_category"
                                    checked={Number(formData?.parent_category) === 1}
                                    onChange={handleInput}
                                />
                            </div>
                        </FormContainer>

                        {Number(formData?.parent_category) === 0 && (
                            <>
                                <MessageLabel text="Select Parent Category" />
                                <select
                                    name="parent_id"
                                    value={formData?.parent_id || ""}
                                    onChange={handleInput}
                                    className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color"
                                >
                                    <option value="">Choose a category</option>
                                    {flatOptions.map((opt) => (
                                        <option
                                            className="theme-bg-color theme-text-color"
                                            key={opt.id}
                                            value={opt.id}
                                        >
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>
                                {formDataError?.parent_id && (
                                    <p className="text-danger">{formDataError.parent_id}</p>
                                )}
                            </>
                        )}

                        <div className="card p-3 mt-3">
                            <FieldRenderer2
                                pageIdentifier={id ? "radio_station_category.edit" : "radio_station_category.create"}
                                entityType="radio_station_category"
                                entityId={id}
                                text="Additional Fields"
                            />
                            <FieldRenderer
                                pageIdentifier={id ? "radio_station_category.edit" : "radio_station_category.create"}
                                entityType="radio_station_category"
                                entityId={id}
                                onChange={setCustomFieldValues}
                            />
                        </div>
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text="Images" />
                        <MessageLabel text="Cover Image" />
                        <p className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">
                            Select the image( 1:1 Ratio or 1080x1080px )
                        </p>
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={coverImageFile}
                            uploadedImage={formData?.image_url}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.image = el)}
                            name="image"
                            id={isEditing ? id : undefined}
                            accept="image/jpeg,image/png,image/jpg"
                            error={formDataError?.image}
                        />

                        <MessageLabel text="Banner Image" />
                        <p className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">
                            Select the image( 16:9 Ratio or 1280x720px )
                        </p>
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={bannerImageFile}
                            uploadedImage={formData?.banner_image_url}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.banner_image = el)}
                            name="banner_image"
                            id={isEditing ? id : undefined}
                            accept="image/jpeg,image/png,image/jpg"
                            error={formDataError?.banner_image}
                        />
                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text="Status" />
                        <div className="d-flex justify-content-between mb-2">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text="In Home" />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch
                                    name="in_home"
                                    checked={formData?.in_home == 1}
                                    onChange={handleInput}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text="In Menu" />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch
                                    name="in_menu"
                                    checked={formData?.in_menu == 1}
                                    onChange={handleInput}
                                />
                            </div>
                        </div>
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton
                    className="px-3 py-1 m-0 ms-auto"
                    saveMethod={handleStore}
                    saveText="Save"
                />
            </FormContainer>
        </>
    );
};

export default RadioStationCategoryAddEdit;
